$(function() {

    // RAP-3554 Temp polyfill for IE11 fetch and abortcontroller.
    // LO: moved into its own file to reduce clutter.
    // IgnoreSuccess added in as can't add success attribute to all ELE calls as some go directly through toJson functions
    ele.handleAJAX = function () {
        /*
            This was created to try to refactor the way we handle errors returned from AJAX calls to the server
            The server should return a success (boolean) and a message (string) parameter
            The function will handle any 'success: false' errors by displaying a notification on the page.
            The error message for the notification will always come from the server, not from the front end, as that is the point of handling failures (rather than having a blanket front end message for all possible errors or translating some kind of error code)
            There always needs to be a .notifications div on the page, I have decided to make this compulsory rather than bend to all possible conditions, as we are trying to refactor here
            if a success true is returned then the success callback is used

            Common issue - Server returns SUCCESS and MESSAGE in caps, make sure the server methods have their object keys wrapped in quotes to ensure lower case
         */

        return function(type, destination, data, ignoreSuccess) {

            //set up timeouts on fetch
            const controller = new AbortController();
            const signal = controller.signal;
            setTimeout(() => controller.abort(), 60000);

            let fetchData = {
                method: type,
                signal: signal
            };

            if (data) {
                let formData = new FormData();
                for (let key in data) {
                    formData.append(key, data[key]);
                }
                fetchData.body = formData;
            }

            return fetch(destination, fetchData).then(response => {
                if(!response.ok) {
                    if(response.status === 404) throw new Error("Not found")
                    else if(response.status === 401) throw new Error("Unauthorized")
                    else if(response.status === 403) throw new Error("Unauthorized")
                    else throw new Error("Other error")
                }
                else {
                    return response;
                }
            }).then(response => {
                return response.json(); //response is now the json returned from server
            }).then(response => {
                if (ignoreSuccess || response.success) {
                    return response;
                } else {
                    console.log('Success false. Error HA30122010');
                    $('.notifications')
                        .removeClass('cls_empty') // Some pages had a variant of the messages box which I am allowing to live
                        .empty()
                        .append(ele.notification(i18n(response.message), 'error'));
                    throw response;
                }
            }).catch(e => {
                if (e.message && (e.message.indexOf("abort") > -1 || e.message.indexOf("Failed to fetch") > -1)) {
                    let modal = ele.modal.confirm("<h3>" + i18n('js_timout') + "</h3><p>" + i18n('js_timout_c') + "</p>");
                    modal.parent().find('.e_cancel').hide();
                }
                throw e;
            });
        }
    }();

	// Change security q's question list dropdown

    $('#changeSecurityQsQuestionList').change(function(){
        var chosenOption = $(this).val();
        if(chosenOption === 'Other'){
            $('#CustomerPasswordChallenge').val('');
            $('#changeSecurityQsQuestionListOther').show();
        }
        else {
            $('#CustomerPasswordChallenge').val(chosenOption);
            $('#changeSecurityQsQuestionListOther').hide();
        }
    });

    var $emailInput = $('#RegisterFormCustomerEmail');
    if ($emailInput.length > 0) {
        $emailInput.on('change', function(){
            let value = $emailInput.val();
            $emailInput.val(value.trim());
        })
    }

    $('.clear-icon i').on('click', function(){
        $('#search').val(''); // Clear the input field
        $('#header-search').val(''); // Clear the input field
        $('#search').focus(); // Optional: focus the input after clearing
    });


	// Change security q's form submission

    var $changeSecurityQsForm = $("#changeSecurityQsForm");
    if ($changeSecurityQsForm.length > 0) {
        let changeSecurityQsFormFunction =
            function (form) {
                form.validate(ele.validations.ChangeSecurityQuestion);
                form.submit(function (e) {
                    e.preventDefault();
                    var me = this;
                    if (form.valid()) {
                        ele.handleAJAX(
                            "POST",
                            ele.uri.buildUrl('changeSecurityQsAjax'),
                            $(me).serializeObject()
                        ).then(response => {
                            form.hide();
                            $('.notifications').empty().append(ele.notification(response.message, 'success')).hide().fadeIn("slow");
                        });
                    }
                });
            }
        changeSecurityQsFormFunction($changeSecurityQsForm);
    }

	// nav for vanillaw based sites  *****************************
	
		$('#ele-header #nav a, #ele-header #nav span, #ele-header .collection, header #nav a, header #nav span, header .collection').hover(
			function() {
				$(this).parent().children('.collection').show();
				$(this).addClass('hoverCraft');
				$(this).parent().addClass('hoverCraft');
			}, function() {
				$(this).parent().children('.collection').hide();
				$(this).removeClass('hoverCraft');
				$(this).parent().removeClass('hoverCraft');
			}
		);

    // LawAssure 2019 rebrand sites hamburger navigation

        $('.navHamburger a').click(function(){
            $('.navHamburger a').toggleClass('active');
            $('.navHamburgerContent').toggleClass('visible');
            $('.dropdown').removeClass('active');
            $('.dropdown .dropWrap').removeClass('show');
        });

        $('.dropdown').click(function(){
            let sameDropdown = false;
            if($(this).hasClass('active')) {
                sameDropdown = true;
            }
            $('.dropdown').removeClass('active');
            $('.dropWrap').removeClass('show');
            if(!sameDropdown) {
                $('.' + $(this).attr('data-child')).addClass('show');
                $(this).addClass('active');
            }
        });

	// this prevents the user from proceeding beyond the rule 2 without agreement ************************************************
		
		$('.ele-basketFirmRule2 form').validate({
			rules: {
	            'accept': {
	                required: true
	            }
	    	},
	        messages: {
	            'accept': {
	                required: i18n('js_valid_terms')
	            }
	        }
		});

		$(".ele-basketFirmRule2 #acceptTerms").change(function(){
			if ($(this).is(":checked")){
				$(".ele-basketFirmRule2 form .btn-terms-continue").prop("disabled", false);
			} else {
				$(".ele-basketFirmRule2 form .btn-terms-continue").prop("disabled", true);
			}
		});
		$('.ele-basketFirmRule2 form').bind('submit', function() {
			if (!$(this).valid()) {
				alert(i18n('js_valid_terms'));
				$(this).find('.checkout-terms-checkbox').addClass('error')
				return false;
			}
			
		})

    // This stop the continue button being pressed repeatedly on the forcerule2 event page

        /*$('#loginRule2Form').one('submit', function() {
            if($('#customertermsaccepted:checked').length > 0) {
                $('#loginRule2Form, input[type="submit"]').prop('disabled', 'true');
            }
        });*/

    /* password field show/hide toggle */
    $("a.show-hide-toggle").on("click", function(e) {
        e.preventDefault();

        let $toggle = $(this);
        let input = $toggle.siblings("input");

        let $icon = $toggle.find("i");
        if ($icon.length === 0) {
            $icon = $("<i/>").appendTo($toggle);
        }

        if (input.prop("type") === "password") {
            input.prop("type", "text");
            $toggle.addClass("active");
            $icon.removeClass("far fad").addClass("fad fa-eye");
        } else {
            input.prop("type", "password");
            $toggle.removeClass("active");
            $icon.removeClass("far fad").addClass("far fa-eye");
        }
    });

    /* ************************************* DSR  ***************************************************** */

    var lockOrderFinalButtons = function($form) {
        if ($form.data("orderFinalSubmitting")) {
            return false;
        }
        $form.data("orderFinalSubmitting", true);
        var $btns = $form.find(".btn-placeorder");
        var loadingText = "Please wait...";
        if (typeof i18n === "function") {
            var translated = i18n("js_checkout_pay_now_loading");
            if (translated && translated !== "js_checkout_pay_now_loading") {
                loadingText = translated;
            }
        }
        // Defer disable so the browser can complete the native POST (ELE-22008)
        setTimeout(function() {
            $btns.prop("disabled", true).css("opacity", 0.5).val(loadingText);
        }, 0);
        return true;
    };

    var checkDSRStatus = function(){
        if ($("form#orderFinal").data("orderFinalSubmitting")) {
            return;
        }
        if ($('.DSRpaymentObligation').is(":checked")) {
            $("form#orderFinal .btn-placeorder").prop("disabled", false).css("opacity", 1);
        } else {
            $("form#orderFinal .btn-placeorder").prop("disabled", true).css("opacity", 0.5);
        }
    }

    if ($("form#orderFinal").length > 0) {

        if ($("form#orderFinal .DSRpaymentObligation").length > 0) {
            checkDSRStatus();
            $('.DSRpaymentObligation').change(function(){
                checkDSRStatus();
            });

            $("#checkout-final-dsrlink").on("click", function(){
                var $dsrdiaglog =  ele.modal.create({
                    content: $($("#template_checkout_dsr").html()),
                    dialogClass: "e_modalFullText",
                    title: i18n('js_checkout_final_dsr_title')
                });
                $dsrdiaglog.dialog("open");
            });
        }

        $("form#orderFinal").submit(function() {
            if ($("form#orderFinal .DSRpaymentObligation").length > 0 && !$('.DSRpaymentObligation').is(":checked")) {
                $(this).find('.DSRpaymentObligation').addClass('error');
                return false;
            }
            return lockOrderFinalButtons($(this));
        });
    }

    /* ************************************* file list  ***************************************************** */


    if ($("#fileListComponent").length > 0) {
        $("#fileListComponent a.fileListToggle").on("click", function(){
           $(this).siblings(".fileList").toggle();
           return false;
        });
    }

    /* ************************************* BASKET VOUCHER  ***************************************************** */

    $("#basketVoucherChange").on("click", function(){
       $(".basketVoucher .basketVoucherApplied").hide();
       $(".basketVoucher form").show();
       return false;
    });

		
	
	/*****************************************************
	 * 
	 * Where: 			View page "basketSelectFirms.cfm"
	 * What: 			Lawfirm selection and More info 
	 * 					show/hide functionality.
	 * Created:			KA 13 May 2008
	 * Last changed: 	KA 15 January 2009
	 * 
	 *****************************************************/
		
	if ($('body#checkout').length ) {
		 
		//Change law firm functionality
		$('.ele-basketSelectFirms')
		.find('.e_products .e_changeLawfirm').show()
		.find('.e_change').show().bind('click', function(){
			var productRoot = $(this).parents('.e_product');
			
			productRoot.find('.e_note1').show();
			
			//Save Radios and labels
			var radios = productRoot.find('.e_lawfirm INPUT[type=radio]');
			var radioLabels = productRoot.find('.e_lawfirm LABEL');
			
			//Show the hidden radio's
			radios.not(':checked').parent().show()
			
			//Deselect selected lawfirm
			radios.removeAttr('checked')
	
			radios.one('click', function(){
				radios.not(':checked').parent().hide();
				productRoot.find('.e_changeLawfirm').show();
				
				$('.e_nav .e_inpSubmit').unbind()
				productRoot.find('.e_note1').hide()
			});
			
			productRoot.find('.e_changeLawfirm').hide();
			
			//Disable Confirm button when firm selection incomplete
			$('.e_nav .e_inpSubmit').unbind().bind('click', function(){
				alert('You have not selected a law firm')
				return false
			})
		})
		
		//More info show/hide functionality
		$('.ele-basketSelectFirms .e_lawfirm .e_chunk4').show()
		.find('A.e_moreInfo').bind('click', function(){
			$(this).find('.e_less').toggle()
			$(this).find('.e_more').toggle()
			$(this).parents('.e_lawfirm').find('.e_desc').toggle()		
			
		})
		.find('.e_less').hide()
	}
	
        
    // This clears the search input when you click it, it also disables the search button if the field is empty *****************************************
    $(document).ready(function(){
    
        $('#searchJurisdiction select').on("change", function(){
            $(this).closest("form").submit();
        })

        $('#articlesPerPage').change(function(){
            let URL = ele.uri.buildUrl('bulletinarticles', {"pagesize": $(this).val()});
            window.location.href = URL;
        });

        // Loads in Cookie notice to the cookie panel
        $('.cookieNoticeAjax').on('click', function(){
            if($( "#cookieNoticeTarget" ).html().length == 0) { 
                $.get(ele.uri.buildUrl('cpage', {"ajax": 1, "c": "text_cookie_notice", "title": 1}), function (data) {
                    $("#cookieBox").addClass('show-cookie-notice');
                    $("#cookieNoticeTarget").html(data);
                    $('.closeCookieNotice').removeClass('sHidden');
                })
                    .fail(function() {
                        window.location = ele.uri.buildUrl('cpage', {"c": "cookie_notice"});
                    });
            } else {
                $("#cookieNoticeTarget").toggle();
                $('.closeCookieNotice').addClass('sHidden');
                $("#cookieBox").toggleClass('show-cookie-notice');
            }
        });
        
        $("#bulletinSearchForm").submit(function () {
            $(".bulletinArticles").empty();
            $("#bulletin-article-loading").removeClass("sHidden");
        });

        if($('#BrowserMessage').length){
            $('body').prepend($('#BrowserMessage')); 
            if($('.navbar').length){
                $('.navbar').css('z-index', '1');
                $('.navbar').css('position', 'initial');
            }
            if($('.pageContainer').length){
                $('.pageContainer').css('height', 'auto');
            }
            if($('#cookieBox').length){
                $('#cookieBox').css('margin-top', '100px');
            }
        }

        if($('#maintenance_content').length){
            $('body').prepend($('#maintenance_content')); 
        }

        $('.checkout-terms-buttons .btn-terms-print').on('click', function(){
            console.log('Print rule 2 letter');
            ele.print.elem($('#rule2letter'));
        });

        $('#bulletin-form').on('submit', function(ev){
            ev.preventDefault();
            var form = $(this);
            var actionUrl = form.attr('action');
            $.ajax({
                type: "POST",
                url: actionUrl,
                data: form.serialize(),
                success: function()
                {
                    $(".bulletinPreferencesForm").hide();
                    $(".e_subscribe").hide();
                    $("#bulletin-changeconfirm").show();
                },
                error: function()
                {
                    ele.modal.confirm("There was a problem while changing your preferences. Please contact technical support.");
                }
            });
        });
    });
    

	// Attaches tooltips via jQuery UI *************************************************************************************************

    $.widget("ui.tooltip", $.ui.tooltip, {
        options: {
            content: function () {
                return $(this).prop('title');
            }
        }
    });
    $('.tooltip, .tooltipQuick').tooltip({
        position: {
            my: "center bottom-20",
            at: "center top",
            using: function( position, feedback ) {
                $( this ).css( position );
                $( "<div>" )
                    .addClass( "arrow" )
                    .addClass( feedback.vertical )
                    .addClass( feedback.horizontal )
                    .appendTo( this );
            }
        }
    });

    /*
    //keeps tooltips on when clicked. Useful for targetting in DOM explorer for styling, etc
    let clicked;
    $('.tooltip').on('mouseleave focusout mouseover focusin', function(event) {
        if (clicked) {
            event.stopImmediatePropagation();
        }
    }).tooltip().click(function() {
        var $this = $(this);
        var isOpen = $this.data('tooltip');
        var method = isOpen ? 'close' : 'open';
        if (method === 'open') {
            clicked = true;
        } else {
            clicked = false;
        }
        $this.tooltip(method);
        $this.data('tooltip', !isOpen);
    });*/

	// intercept page leave in checkout Sagepay stages
		if ($(".ele-creditCard3DSecure, #ThreeDSecureFrame").length > 0) {
						
			window.onbeforeunload = function(e) {
				return i18n('js_checkout_payment_warning');
			}	
			
		}
    
    $('.notification_close').on('click', function(){
        // There could be many notifications on the page, so hide only the immediate parent
        $(this).closest('.notification').hide(); 
    });

    if ($("#backToPreviousPage").length > 0) {
        $("#backToPreviousPage").on('click', function(){
            window.history.back();
        });
    }
});
